package com.dignicate.web.ui.components.footer

import androidx.compose.runtime.Composable
import com.dignicate.web.domain.FooterNav
import com.dignicate.web.domain.LinkKind
import com.dignicate.web.ui.util.navigateAndScrollTop
import org.jetbrains.compose.web.attributes.href
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.JustifyContent
import com.dignicate.web.css.TextAlign
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import com.dignicate.web.css.textAlign
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

private const val START_YEAR = 2019

@Composable
fun Footer(nav: FooterNav, onNavigate: (String) -> Unit) {
    Div({ classes("site-footer") }) {
        Div({ classes("footer-inner") }) {
            // top row: left company (old small links removed)
            Div({ classes("footer-top") }) {
                Div({ }) { Text("Dignicate, LLC") }
            }

            // middle: 4-column footer nav
            Div({ classes("footer-columns") }) {
                nav.columns.forEach { col ->
                    Div({ classes("footer-column") }) {
                        Span({ classes("footer-title") }) { Text(col.title) }

                        col.items.forEach { item ->
                            val href = item.href
                            if (href == null) {
                                Span({ classes("footer-link", "isDisabled") }) { Text(item.label) }
                            } else {
                                when (item.kind) {
                                    LinkKind.External -> {
                                        A(attrs = {
                                            classes("footer-link")
                                            href(href)
                                            attr("target", "_blank")
                                            attr("rel", "noopener noreferrer")
                                        }) {
                                            Text(item.label)
                                            Span({ classes("externalIcon") }) { Text("↗") }
                                        }
                                    }
                                    LinkKind.Internal -> {
                                        // Internal link — use navigateAndScrollTop helper
                                        Span({
                                            classes("footer-link")
                                            onClick {
                                                navigateAndScrollTop(
                                                    onNavigate,
                                                    href
                                                )
                                            }
                                        }) { Text(item.label) }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // bottom row: thin border + copyright + build info
            Div({ classes("footer-bottom") }) {
                val currentYear = js("new Date().getFullYear()") as Int
                val yearText = if (currentYear > START_YEAR) "${START_YEAR}–${currentYear}" else "$currentYear"

                // Centering wrapper: full-width container that centers its child block
                Div({
                    style {
                        display(DisplayStyle.Flex)
                        justifyContent(JustifyContent.Center)
                        width(100.percent)
                    }
                }) {
                    // Inner meta block: column, centered, text-align:center
                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            flexDirection(FlexDirection.Column)
                            alignItems(AlignItems.Center)
                            textAlign(TextAlign.Center)
                            gap(4.px)
                            maxWidth(900.px)
                        }
                    }) {
                        // Copyright text (centered)
                        Span({ style { color(Color("var(--muted, #666)")); fontSize(15.2.px) } }) {
                            Text("© $yearText Dignicate, LLC. All rights reserved.")
                        }

                        // Build info: small, monospace, slightly faded, centered
                        BuildInfoFooter()
                    }
                }
            }
        }
    }
}
